import { render, staticRenderFns } from "./EditComparisonTable.vue?vue&type=template&id=7d2ece92&"
import script from "./EditComparisonTable.vue?vue&type=script&lang=js&"
export * from "./EditComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports